module.exports = __webpack_public_path__ + "fonts/411051cb61bcda5517943601e8734cea.ttf";